export default function ShareLinks() {
  // .copy_link要素を取得
  const copyLinkContainer = document.querySelectorAll('.copy_link');

  copyLinkContainer.forEach((copyLink) => {
    const button = copyLink.querySelector('button');
    const feedback = copyLink.querySelector('span');

    if (button && feedback) {
      button.addEventListener('click', (e) => {
        const url = window.location.href;
        navigator.clipboard.writeText(url).then(
          () => {
            feedback.classList.add('visible');
            setTimeout(() => {
              feedback.classList.remove('visible');
            }, 2500);
          },
          () => {
            return;
          },
        );
      });
    } else {
      return;
    }
  });
}
